// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import get from 'lodash/get'
import React from 'react'
import { Query } from 'react-apollo'
import { EditableConsumer } from '../../common/context/EditableContext'
import DeleteButton from '../../common/iconButtons/DeleteButton'
import CreatableSelect from '../../common/select/CreatableSelect'
import { i18n } from '../index'
import { fetchAvailableNightTasks } from '../station/stationQueries'
import type { NightTask } from '../station/stationTypes'
import css from './items.css'

const nightTasksToOptions = (data: Array<NightTask>, exclude: Array<string>) =>
  data
    .filter((item) => exclude.indexOf(item.name) === -1)
    .map((item) => ({
      label: item.name,
      value: item.id,
    }))

type NightTaskFormProps = {
  stationId: string
  data: Array<string>
  onAdd: (...args: Array<any>) => any
}

const NightTaskForm = ({ stationId, data, onAdd }: NightTaskFormProps) => (
  <div className={css.itemForm}>
    <Query<
      {
        availableNightTasks: Array<NightTask>
      },
      {
        stationId: string
      }
    >
      query={fetchAvailableNightTasks}
      variables={{
        stationId,
      }}
    >
      {({ data: userData, error, loading }) => (
        <CreatableSelect
          className={css.select}
          placeholder={i18n.t('dailyManagement.label.newNightTaskPlaceholder')}
          options={nightTasksToOptions(get(userData, 'availableNightTasks', []), data)}
          onChange={({ label }) => {
            onAdd(label)
          }}
          isSearchable
          isCreatable
        />
      )}
    </Query>
  </div>
)

type NightTaskListProps = {
  data: Array<string>
  emptyText: string
  onDelete: (...args: Array<any>) => any
}

const NightTaskList = ({ data, emptyText, onDelete }: NightTaskListProps) => (
  <div className={css.itemList}>
    {data && data.length ? (
      <EditableConsumer>
        {({ isEditable }) => (
          <table className={css.table} cellPadding={0} cellSpacing={0}>
            <tbody className={!isEditable ? css.isList : ''}>
              {[...(data ?? [])]
                .sort((a, b) => a.localeCompare(b))
                .map((value, i) => (
                  <tr key={i}>
                    <td>{value}</td>
                    <td className={css.actionsCell}>{isEditable && <DeleteButton onClick={() => onDelete(i)} />}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </EditableConsumer>
    ) : (
      <p className={css.emptyText}>{emptyText}</p>
    )}
  </div>
)

type NightTasksProps = {
  placeholder: string
  data: Array<string>
  stationId: string
  emptyText: string
  onAdd: (...args: Array<any>) => any
  onDelete: (...args: Array<any>) => any
}

const NightTasks = ({ placeholder, data, stationId, emptyText, onAdd, onDelete }: NightTasksProps) => (
  <div className={css.component}>
    <EditableConsumer>
      {({ isEditable }) =>
        isEditable && <NightTaskForm stationId={stationId} data={data} placeholder={placeholder} onAdd={onAdd} />
      }
    </EditableConsumer>
    <NightTaskList data={data} emptyText={emptyText} onDelete={onDelete} />
  </div>
)

export default NightTasks
